import localforage from 'localforage'
import axios from 'axios'
import VueGeolocation from '../helpers/vue-geolocation';
import { router } from '../router'
import store from '../store'

export const geolocation = {
    state: {
        geolocation: null,
        sendingGeolocation: false,
        lastGeolocationRequest: 0
    },
    mutations: {
        GEOLOCATION_READY(state, status) {
            state.geolocationReady = status
        },
        WATCH_GEOLOCATION(state, geolocation) {
            state.geolocation = geolocation
        },
        SET_LAST_GEOLOCATION_REQUEST(state, lastGeolocationRequest) {
            state.lastGeolocationRequest = lastGeolocationRequest
        },
        SET_SENDING_GEOLOCATION_STATUS(state, sendingGeolocation) {
            state.sendingGeolocation = sendingGeolocation
        }
    },
    actions: {
        watchGeolocation({commit, dispatch, getters}) {
            if (getters.isSendingGeolocation === false) {
                VueGeolocation.watchLocation((coordinates) => {
                    let timestamp = Math.round(Date.now() / 1000).toString()
                    let geolocation = {
                        latitude: coordinates.coords.latitude,
                        longitude: coordinates.coords.longitude,
                        accuracy: coordinates.coords.accuracy,
                        timestamp
                    }
                    commit('WATCH_GEOLOCATION', geolocation)
                    commit('SET_SENDING_GEOLOCATION_STATUS', true)

                    // if interval is greater than 5 mins
                    if (timestamp - parseInt(getters.getLastGeolocationRequest) > 60 * 5) {
                        dispatch('sendGeolocation')
                        if('serviceWorker' in navigator && 'SyncManager' in window){
                            navigator.serviceWorker.ready.then(sw => {
                                sw.sync.register('sync-confirmations')
                            })
                        }
                    }
                }, {
                    enableHighAccuracy: true
                })
            }
        },
        sendGeolocation({commit, getters, dispatch}) {
            dispatch('checkTokenValidity').then(() => {
                localforage.getItem('authUser').then((headers) => {
                    // check if geolocation is ready
                    if (headers) {
                        commit('SET_LAST_GEOLOCATION_REQUEST', getters.getGeolocation.timestamp)
                        return axios.put(`${process.env.VUE_APP_API}geolocations`, {
                            latitude: getters.getGeolocation.latitude,
                            longitude: getters.getGeolocation.longitude,
                            accuracy: getters.getGeolocation.accuracy,
                            timestamp: getters.getGeolocation.timestamp
                        }, {
                            headers: JSON.parse(headers)
                        })
                            .catch((e) => {
                                console.log(e);
                            })
                    }
                })
            }).catch(error => {
                router.push({name: 'logout'})
                store.dispatch('addNotification', {
                    type: 'warning',
                    content: error
                })
            })
        }
    },
    getters: {
        isSendingGeolocation: (state) => {
            return state.sendingGeolocation
        },
        getLastGeolocationRequest: (state) => {
            return state.lastGeolocationRequest
        },
        getGeolocation: (state) => {
            return state.geolocation
        }
    }
}
